import React, { Component } from 'react'
import { Table, Button, Row, message, Modal, Spin } from "antd"
import moment from 'moment'

export default class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      exportModalShowed: false
    }
  }

  downloadDetailData = () => {
    const { downloadDetailData } = this.props.store
    this.setState({
      exportModalShowed: true
    })
    downloadDetailData()
      .then(
        res => {
          const exportDataUrl = res.url
          this.setState({
            exportModalShowed: false,
          })
          if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
          let a = document.createElement("iframe")
          a.setAttribute("src", exportDataUrl)
          a.setAttribute("id", "export-a-tag")
          a.setAttribute("style", "display:none;")
          if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
        },
        err => {
          message.error("导出失败，请您重试！")
          this.setState({
            exportModalShowed: false,
          })
        }
      )
  }

  render() {
    const { taskDetailData } = this.props.store

    const startTime = taskDetailData && moment(taskDetailData.startTime).format('YYYY-MM-DD')
    const endTime = taskDetailData && moment(taskDetailData.endTime).format('YYYY-MM-DD')

    let softResultStatisticsCopy, reviewResultStatisticsCopy, sdResultStatisticsCopy

    if (taskDetailData && taskDetailData.softResultStatistics) {
      softResultStatisticsCopy = taskDetailData.softResultStatistics.filter((soft, index) => index !== 0)
    }

    if (taskDetailData && taskDetailData.reviewResultStatistics) {
      reviewResultStatisticsCopy = taskDetailData.reviewResultStatistics.filter((soft, index) => index !== 0)
    }
    
    if (taskDetailData && taskDetailData.sdResultStatistics) {
      sdResultStatisticsCopy = taskDetailData.sdResultStatistics
    }

    const columns = [{
      title: 'PGS',
      className: 'ta-c',
      key: 'pgta',
      children: [{
        title: "名称",
        className: "ta-l",
        dataIndex: "pgtaName",
        key: "pgtaName",
        render: (text) => {
          return (
            <div className={text.indexOf('-') !== -1 ? 'ele-empty' : ''} >
              {text}
            </div>
          )
        }
      }, {
        title: "数量",
        className: "ta-r",
        dataIndex: "pgtaCount",
        key: "pgtaCount",
      }, {
        title: "百分比",
        className: "ta-r",
        dataIndex: "pgtaPercent",
        key: "pgtaPercent",
      }]
    }, {
      title: 'gDNA CNV-seq',
      className: 'ta-c',
      key: 'gcnv',
      children: [{
        title: "名称",
        className: "ta-l",
        dataIndex: "gdnaName",
        key: "gdnaName",
        render: (text) => {
          return (
            <div className={text.indexOf('-') !== -1 ? 'ele-empty' : ''} >
              {text}
            </div>
          )
        }
      }, {
        title: "数量",
        className: "ta-r",
        dataIndex: "gdnaCount",
        key: "gdnaCount",
      }, {
        title: "百分比",
        className: "ta-r",
        dataIndex: "gdnaPercent",
        key: "gdnaPercent",
      }]
      }]
    
    const sdColumns = [{
      title: "APP",
      className: "ta-l",
      dataIndex: "appName",
    }, {
      title: "样本量",
      className: "ta-r",
      dataIndex: "total",
    }, {
      title: "SD均值",
      className: "ta-r",
      dataIndex: "average",
    }, {
      title: "SD≤2.5",
      className: "ta-r",
      dataIndex: "small",
    }, {
      title: "2.5<SD≤3.5",
      className: "ta-r",
      dataIndex: "medium",
    }, {
      title: "SD>3.5",
      className: "ta-r",
      dataIndex: "large",
    }]
    return (
      <div className="task-content">
        <Row type="flex" justify="end" align="middle" className="content">
          <Button
            style={{ marginRight: 10 }}
            onClick={this.downloadDetailData}
          >
            下载
          </Button>
        </Row>
        <span className="statistics-table-title">
          {startTime}{taskDetailData ? '~' : ''}{endTime} 软件结果统计
        </span>
        <Table
          rowKey={record => record.id}
          bordered
          columns={columns}
          dataSource={softResultStatisticsCopy ? softResultStatisticsCopy.slice() : []}
          pagination={false}
        />
        <span className="statistics-table-title">{startTime}{taskDetailData ? '~' : ''}{endTime} 人工审核结果统计</span>
        <Table
          rowKey={record => record.id}
          bordered
          columns={columns}
          dataSource={reviewResultStatisticsCopy ? reviewResultStatisticsCopy.slice() : []}
          pagination={false}
        />
        <span className="statistics-table-title">{startTime}{taskDetailData ? '~' : ''}{endTime} SD统计</span>
        <Table
          rowKey={record => record.id}
          bordered
          columns={sdColumns}
          dataSource={sdResultStatisticsCopy ? sdResultStatisticsCopy.slice() : []}
          pagination={false}
        />
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/TaskDetail/index.js